module.exports = __webpack_public_path__ + "img/Schnurbart.8fb58cb1.jpg";